import React, { useEffect, useState } from "react";
import "./App.css";

import PublicInterface from "./interface/publicInterface";
import AdminInterface from "./interface/adminInterface";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const [user, setUser] = useState("public");

  useEffect(() => {
    if (sessionStorage.token) {
      setUser("admin");
    }
  }, [user]);

  return (
    <>
      <PublicInterface />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      {user === "admin" && <AdminInterface />}
    </>
  );
}

export default App;
